<template lang="html">
  <sui-modal id="modalImprint" v-model="open" :closable="false">
    <sui-modal-header>Datenschutzerklärung</sui-modal-header>
    <sui-modal-content scrolling>
      <sui-modal-description>
        <fieldset>
            <pre>
# Datenschutzerklärung
Bei der Nutzung des Online-Shops auf shop.lan1.de werden verschiedene Daten erhoben.
Wir nehmen den Schutz Ihrer Daten sehr ernst und informieren Sie daher nachfolgend
über den Umfang und Zweck der Datenverarbeitung.

I.   Verantwortlicher
     Als Betreiberin des Shops ist verantwortlich:
     LAN1 Hotspots GmbH (nachfolgend "LAN1")
     Gaußstraße 158
     22765 Hamburg
     E-Mail: info@lan1.de 
     Tel.: 040 317 6666 66
     Impressum: https://www.lan1.de/impressum

II.  Fragen zum Datenschutz
     Bei Fragen zum Datenschutz können Sie sich jederzeit wenden an
     Herrn Jörg Hümmer
     LAN1 Hotspots GmbH
     E-Mail: datenschutz@lan1.de
     Tel.: 040 317 6666 16

III. Umfang und Rechtsgrundlage der Datenerhebung
     1.  LAN1 erhebt und verwendet Daten, die für Abwicklung Ihres Kaufes also zur
         Vertragsdurchführung. Rechtsgrundlage für diese Datenverarbeitung ist
         Art. 6 Abs. 1 lit. b DSGVO. Zudem erhebt und verwendet LAN1 Daten zur
         Verbesserung der eigenen Dienste und für statistischen Zwecke. Dies erfolgt
         aufgrund berechtigen Interesses auf der Rechtsgrundlage des Art. 6 Abs. 1 lit. f DSGVO.
     2.  Im Einzelnen erheben wir folgende Daten:
         - Ihre E-Mail-Adresse, für den Versand der Rechnung und des erworbenen Voucher.
         - Ihre Handynummer, sofern Sie Ihren erworbenen Voucher per SMS erhalten möchten.
         Ihre E-Mail-Adresse und/oder Ihre Handynummer dient ausschließlich der Übermittlung
         des Vouchers. Zudem überprüfen wir, ob Sie den Voucher erhalten haben. Eine sonstige
         Verwendung oder Weitergabe der Daten erfolgt nicht.
     3.  Für die Zahlungsabwicklung arbeiten wir mit dem Zahlungsdienstleister
         SIX Payment Services AG zusammen (s. hierzu ausführlich unter V.).
         Dort werden im Zuge der Bezahlung Ihres Kaufes die von Ihnen gemachten Angaben über
         Zahlungs- und Rechnungsdaten direkt bei SIX Payment gespeichert und für den
         Zahlungsvorgang verarbeitet. LAN1 hat Zugriff auf die dort gespeicherten Daten.
         Sie können beim Kauf selbst entscheiden, welche Daten Sie angeben möchten.
         Ist beispielsweise eine für den Umsatzsteuerabzug berechtigte Rechnung erwünscht,
         können Sie die dafür erforderlichen Daten angeben. Im Einzelnen können entsprechend
         Ihrer Wahl folgende Angaben erhoben und gespeichert werden: Ihre Kundenadresse
         (Anrede, Vor-/Nachname, Straße, PLZ, Ort, Land, E-Mail-Adresse und Telefonnummer)
         und Ihre Zahlungsdaten (wahlweise Mastercard, Visa, Bezahlen per Online Banking (Klarna),
         Paypal oder Masterpass by Mastercard).

IV.  Verwendung und Löschung der Daten
     Die Daten werden ausschließlich für die Abwicklung des Bestellvorganges verwendet.
     Sie werden entsprechend der gesetzlichen Aufbewahrungsfrist des Finanzamtes für
     10 Jahre gespeichert und dann im Regelfall gem. Art. 17 DSGVO gelöscht, da der Zweck der
     Speicherung entfallen ist. Davon ausgenommen sind Daten, die gemäß den gesetzlichen Bestimmungen
     zwingend vorher gelöscht werden müssen. Ausnahmsweise werden die Daten nicht gelöscht,
     wenn gesetzliche Vorgaben oder sonstige Bestimmung dem entgegenstehen.

V.   Drittanbieter
     LAN1 arbeitet zur Bereitstellung des Shops mit Dienstleistern zusammen, die Daten für
     LAN1 verarbeiten. Dies geschieht innerhalb der gesetzlichen Regelung des Art. 28 DSGVO und
     nur im Rahmen der Weisung von LAN1. Alle Auftragsverarbeiter wurden gemäß den gesetzlichen
     Bestimmungen sorgfältig ausgewählt und erhalten nur Zugriff auf die zur Erbringung der Dienstleistung
     erforderlichen Daten. Die spezifischen unter III. (3) genannten Daten werden zudem direkt von Saferpay,
     einem Tool des Zahlungsdienstleisters SIX Payment Services AG (Hardturmstraße 201, CH-8005 Zürich)
     erhoben. SIX setzt höchste Anforderungen an Daten- und Prozesssicherheit und zertifiziert seine
     Produkte mit PCI DSS. Weitere Informationen zum Schutz von Daten bei SIX erhalten Sie auf der
     Website: https://www.six-payment-services.com/de/site/e-commerce/support/faq.html#security

VI.  Ihre Rechte
     Gemäß der DSGVO informieren wir Sie an dieser Stelle über Ihre Rechte als Betroffener der
     Verarbeitung personenbezogener Daten. Gem. Art. 15 DSGVO haben Sie ein Auskunftsrecht über die
     von Ihnen bei uns gespeicherten Daten. Nach Art. 16 DSGVO haben Sie das Recht unvollständige
     oder falsche Daten berichtigen zu lassen. Sie können zudem nach Maßgabe des Art. 17 DSGVO verlangen,
     dass LAN1 entsprechende Daten löscht, bzw. ggf. nach Art. 18 DSGVO die Verarbeitung einschränkt.
     Ihre Daten können Sie nach Art. 20 DSGVO in einem maschinenlesbaren Format erhalten oder die
     Übermittlung an einen anderen Anbieter fordern. Abschließend haben Sie gem. Art. 77 DSGVO ein
     Beschwerderecht bei der zuständigen Aufsichtsbehörde.

VII. Cookies
     Wir setzen auf unserer Seite Cookies ein. Cookies sind kleine Dateien, die es ermöglichen,
     auf dem Zugriffsgerät der Nutzer (PC, Smartphone o.ä.) spezifische, auf das Gerät bezogene
     Informationen zu speichern. Sie dienen zum einem der Benutzerfreundlichkeit von Webseiten und
     damit den Nutzern (z.B. Speicherung von Logindaten). Die Nutzer können auf den Einsatz der
     Cookies Einfluss nehmen. Die meisten Browser verfügen eine Option mit der das Speichern von Cookies
     eingeschränkt oder komplett verhindert wird. Allerdings wird darauf hingewiesen,
     dass die Nutzung eingeschränkt werden kann.

Stand: 01.08.2018
</pre>



            <h2></h2>
            <p></p>

            <ol style="list-style-type:upper-roman">
              <li>
                Verantwortlicher
                <p>
                  Als Betreiberin des Shops ist verantwortlich:<br>

                  LAN1 Hotspots GmbH (nachfolgend „LAN1“)<br>

                  Gaußstraße 158<br>

                  22765 Hamburg<br>

                  E-Mail: info@lan1.de <br>

                  Tel.:<a href="040317666666" title="Call  040 317 6666 66 via 3CX"> 040 317 6666 66</a><br>

                  Impressum: https://www.lan1.de/impressum
                </p>
              </li>
              <li>
                Fragen zum Datenschutz
                <p>
                  Bei Fragen zum Datenschutz können Sie sich jederzeit wenden an<br>

                  Herrn Jörg Hümmer<br>

                  LAN1 Hotspots GmbH<br>

                  E-Mail: datenschutz@lan1.de<br>

                  Tel.:<a href="040317666616" title="Call  040 317 6666 16 via 3CX"> 040 317 6666 16</a>
                </p>
              </li>
              <li>
                Umfang und Rechtsgrundlage der Datenerhebung
                <ol style="list-style-type:decimal">
                  <li>
                    LAN1 erhebt und verwendet Daten, die für Abwicklung Ihres Kaufes also zur Vertragsdurchführung. Rechtsgrundlage für diese Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO. Zudem erhebt und verwendet LAN1 Daten zur Verbesserung der eigenen Dienste und für statistischen Zwecke. Dies erfolgt aufgrund berechtigen Interesses auf der Rechtsgrundlage des Art. 6 Abs. 1 lit. f DSGVO.
                  </li>
                  <li>
                    Im Einzelnen erheben wir folgende Daten:
                    <ul>
                      <li>Ihre E-Mail-Adresse, für den Versand der Rechnung und des erworbenen Voucher.</li>
                      <li>Ihre Handynummer, sofern Sie Ihren erworbenen Voucher per SMS erhalten möchten.</li>
                    </ul>
                    <p>Ihre E-Mail-Adresse und/oder Ihre Handynummer dient ausschließlich der Übermittlung des Vouchers. Zudem überprüfen wir, ob Sie den Voucher erhalten haben. Eine sonstige Verwendung oder Weitergabe der Daten erfolgt nicht.</p>
                  </li>
                  <li>
                    Für die Zahlungsabwicklung arbeiten wir mit dem Zahlungsdienstleister SIX Payment Services AG zusammen (s. hierzu ausführlich unter V.). Dort werden im Zuge der Bezahlung Ihres Kaufes die von Ihnen gemachten Angaben über Zahlungs- und Rechnungsdaten direkt bei SIX Payment gespeichert und für den Zahlungsvorgang verarbeitet. LAN1 hat Zugriff auf die dort gespeicherten Daten.
                    Sie können beim Kauf selbst entscheiden, welche Daten Sie angeben möchten. Ist beispielsweise eine für den Umsatzsteuerabzug berechtigte Rechnung erwünscht, können Sie die dafür erforderlichen Daten angeben. Im Einzelnen können entsprechend Ihrer Wahl folgende Angaben erhoben und gespeichert werden:
                    Ihre Kundenadresse (Anrede, Vor-/Nachname, Straße, PLZ, Ort, Land, E-Mail-Adresse und Telefonnummer) und Ihre Zahlungsdaten (wahlweise Mastercard, Visa, Bezahlen per Online Banking (Klarna), Paypal oder Masterpass by Mastercard).
                  </li>
                </ol>
              </li>
              <li>
                Verwendung und Löschung der Daten
                <p>
                  Die Daten werden ausschließlich für die Abwicklung des Bestellvorganges verwendet. Sie werden entsprechend der gesetzlichen Aufbewahrungsfrist des Finanzamtes für 10 Jahre gespeichert und dann im Regelfall gem. Art. 17 DSGVO gelöscht, da der Zweck der Speicherung entfallen ist. Davon ausgenommen sind Daten, die gemäß den gesetzlichen Bestimmungen zwingend vorher gelöscht werden müssen.
                  Ausnahmsweise werden die Daten nicht gelöscht, wenn gesetzliche Vorgaben oder sonstige Bestimmung dem entgegenstehen.
                </p>
              </li>
              <li>
                Drittanbieter
                <p>
                  LAN1 arbeitet zur Bereitstellung des Shops mit Dienstleistern zusammen, die Daten für LAN1 verarbeiten. Dies geschieht innerhalb der gesetzlichen Regelung des Art. 28 DSGVO und nur im Rahmen der Weisung von LAN1. Alle Auftragsverarbeiter wurden gemäß den gesetzlichen Bestimmungen sorgfältig ausgewählt und erhalten nur Zugriff auf die zur Erbringung der Dienstleistung erforderlichen Daten.
                  Die spezifischen unter III. (3) genannten Daten werden zudem direkt von Saferpay, einem Tool des Zahlungsdienstleisters SIX Payment Services AG (Hardturmstraße 201, CH-8005 Zürich) erhoben.
                  SIX setzt höchste Anforderungen an Daten- und Prozesssicherheit und zertifiziert seine Produkte mit PCI DSS.
                  Weitere Informationen zum Schutz von Daten bei SIX erhalten Sie auf der Website:
                  https://www.six-payment-services.com/de/site/e-commerce/support/faq.html#security
                </p>
              </li>
              <li>
                Ihre Rechte
                <p>
                  Gemäß der DSGVO informieren wir Sie an dieser Stelle über Ihre Rechte als Betroffener der Verarbeitung personenbezogener Daten.
                  Gem. Art. 15 DSGVO haben Sie ein Auskunftsrecht über die von Ihnen bei uns gespeicherten Daten.
                  Nach Art. 16 DSGVO haben Sie das Recht unvollständige oder falsche Daten berichtigen zu lassen.
                  Sie können zudem nach Maßgabe des Art. 17 DSGVO verlangen, dass LAN1 entsprechende Daten löscht, bzw. ggf. nach Art. 18 DSGVO die Verarbeitung einschränkt.
                  Ihre Daten können Sie nach Art. 20 DSGVO in einem maschinenlesbaren Format erhalten oder die Übermittlung an einen anderen Anbieter fordern.
                  Abschließend haben Sie gem. Art. 77 DSGVO ein Beschwerderecht bei der zuständigen Aufsichtsbehörde.
                </p>
              </li>
              <li>
                Cookies
                <p>Wir setzen auf unserer Seite Cookies ein. Cookies sind kleine Dateien, die es ermöglichen, auf dem Zugriffsgerät der Nutzer (PC, Smartphone o.ä.) spezifische, auf das Gerät bezogene Informationen zu speichern. Sie dienen zum einem der Benutzerfreundlichkeit von Webseiten und damit den Nutzern (z.B. Speicherung von Logindaten). Die Nutzer können auf den Einsatz der Cookies Einfluss nehmen. Die meisten Browser verfügen eine Option mit der das Speichern von Cookies eingeschränkt oder komplett verhindert wird. Allerdings wird darauf hingewiesen, dass die Nutzung eingeschränkt werden kann.</p>
              </li>
            </ol>

        </fieldset>
      </sui-modal-description>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button positive @click="toggle">Close</sui-button>
    </sui-modal-actions>
  </sui-modal>
</template>

<script>
  export default {
    name: 'Privacy',
    props: ['open'],
    methods: {
      toggle(event) {
        if (event) {
          event.preventDefault()
        }
        this.$emit('closeModal')
      },
    },
  };</script>
